
import React, { Component}  from 'react';
import styled from 'styled-components';

import { InputWidget } from 'form/InputWidget';
import Colors from 'ui/Colors';
import {DateTimeWidget} from "form/new/DateTimeWidget";
import {AsyncAutocompleteWidget} from "form/AutocompleteWidget";

const StyledPoint = styled.div`
  margin-bottom: 20px;
  
  .row-1 {
    display: grid;
    grid-template-columns: 18px auto;
    grid-gap: 10px;
    margin-bottom: 15px;
    align-items: center;
  }
  
  .row-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
  }
  
  .row-3 {
    margin-top: 5px;
    color: #828282;
  }
`;

const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  width: 18px;
  font-weight: bold;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
`;

const PointContact = styled.div`
  margin-top: 2px;
  color: ${Colors.Gray1};
`;


export default class OrderDetailPoint extends Component {

  patch = (name, value) => {
    const { orderPoint, context } = this.props;
    const data = {
      points: [{
        id: orderPoint.id
      }]
    };
    data['points'][0][name] = value;
    context.patch(data)
  };

  render() {
    const { context, index, orderPoint } = this.props;
    return (
      <StyledPoint>
        <div className={'row-1'}>
          <div>
            <Index>{index + 1}</Index>
          </div>
          <div style={{wordBreak: 'break-word'}}>
            <div>
              {orderPoint.point_display}
              {orderPoint.point_address && (<span>, {orderPoint.point_address}</span>)}
            </div>

            {orderPoint.point_contact && (
              <PointContact>{orderPoint.point_contact}</PointContact>
            )}

            {(!orderPoint.point_contact && orderPoint.point.contact) && (
              <PointContact>{orderPoint.point.contact}</PointContact>
            )}
          </div>
        </div>
        <div className={'row-2'}>
          <div>
            <AsyncAutocompleteWidget
              value={orderPoint.status}
              url={'catalog/choice'}
              label={'Статус'}
              onChange={(value) => this.patch('status', value)}
              filter={{
                type: 'ORDER_POINT_STATUS'
              }}
              size={'small'}
            />
          </div>
          <div>
            <InputWidget
              value={orderPoint.point_text}
              label={'Точка'}
              size={'small'}
              onChange={(value) => context.setValue(`points.${index}.point_text`, value)}
              onBlur={() => this.patch('point_text', orderPoint.point_text)}
            />
          </div>
        </div>
        {orderPoint.date && (
          <div className={'row-2 pt-15'}>
            <div>
              <DateTimeWidget
                value={orderPoint.date}
                size={'small'}
                label={'Дата подачи'}
                onChange={(value, stringValue) => this.patch('date', value)}
                popperPlacement={'bottom-start'}
              />
            </div>
          </div>
        )}

      </StyledPoint>
    )
  }
}
